import React from "react";
import PropTypes from "prop-types";
import tw from "twin.macro";
import styled from "styled-components";

// Reproduces Bootstrap .container responsive max-widths + horizontal
// padding. dskit overrode the >=1200px breakpoint to 800px (vs Bootstrap's
// 1140px) — kept that override for visual parity.
const ContainerDiv = styled.div`
  ${tw`w-full mx-auto`}
  padding-right: 15px;
  padding-left: 15px;

  @media (min-width: 576px) {
    max-width: 540px;
  }
  @media (min-width: 768px) {
    max-width: 720px;
  }
  @media (min-width: 992px) {
    max-width: 960px;
  }
  @media (min-width: 1200px) {
    max-width: 800px;
  }
`;

const Container = ({ children, className, ...props }) => (
  <ContainerDiv className={className} {...props}>
    {children}
  </ContainerDiv>
);

Container.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string
};

export default Container;
